var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'query-string'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/query-string/index.js' implicitly has an 'any' type.
import qs from "query-string";
import moment from "moment";
import ScrollToTop from "../shared/scrollToTop";
import Busy from "../shared/busy";
import MeetingType from "./meetingType";
import MeetingTopic from "./meetingTopic";
import MeetingTeam from "./meetingTeam";
import MeetingScheduler from "./meetingScheduler";
import MeetingConfirm from "./meetingConfirm";
import MeetingDetail from "./meetingDetail";
import MeetingWithDisplay from "./meetingWithDisplay";
import MeetingService from "../../services/MeetingService";
import MeetingTypeService from "../../services/MeetingTypeService";
import StudentService from "../../services/StudentService";
import PersonService from "../../services/PersonService";
import ProfilePicture from "../shared/profilePicture";
import CampaignService from "../../src/Services/Campaign.service";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import CustomCard from "../../src/View/UI/CustomCard/CustomCard";
import AppointmentCampaignInfoDomainService from "../../src/Domain/AppointmentCampaignInfo/AppointmentCampaignInfo.service";
import { AlertInfo } from "../../src/View/UI/StandardAlerts/StandardAlerts";
import ParamsService from "../../src/Services/Shared/Params.service";
import SEO from "../../src/View/UI/SEO/SEO";
import { getMeetingConfirmRoute, getMeetingDetailRoute, getMeetingSchedulerRoute, getMeetingTeamRoute, meetingTopicRoute, getMeetingTypeRoute, meetingTopicPath, } from "../../src/View/Pages/MeetingRequest/MeetingRequestRoutes";
import { ID_VARIABLE, getPreBaseRoute } from "../index";
import { getMeetingsSchedulePath, getMeetingsBaseRoute, getMeetingsDetailPath, getMeetingsConfirmationPath, } from "../../src/View/Pages/Meeting/MeetingsRoutes";
import FeatureService from "../../src/Domain/Feature/Feature.service";
const timeSlotsCache = {};
const STATUS_FREE = "FREE";
// This is a hacky in-between that allows us to clear out the state as we navigate backwards through the flow
// This needs to be deleted and this code refactored to pass state along the flow instead of up to a central
// controller
const PAGE_STATE_MAPPING = [
    {
        page: "topic",
        // There is state here, but we don't need to clear it, so leave it blank for now
        state: [],
        stateLists: [],
    },
    {
        page: "team",
        state: ["selectedMeetingTeam"],
        stateLists: ["serviceDeliveryLocations"],
    },
    {
        page: "type",
        state: ["selectedMeetingType"],
        stateLists: ["meetingTypes"],
    },
    { page: "scheduler", state: ["selectedTimeSlot"], stateLists: ["timeSlots"] },
];
export default class MeetingController extends Component {
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    constructor(props) {
        super(props);
        this.onStudentPersonChanged = () => {
            this.loadStudentLocation();
            this.loadCourseSchedule();
        };
        this.getQueryString = () => ParamsService.calcNewParams({
            studentAffiliationId: this.state.studentAffiliationId,
        });
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.state = {
            studentAffiliationId: null,
            staffPersonList: null,
            meetingTypeList: null,
            studentPerson: null,
            isThirdPartyScheduler: false,
            availabilityDate: today,
            meetingWithPersonId: null,
            meetingWithAutoAssignedPersonId: null,
            meetingWith: null,
            meetingWithAutoAssigned: null,
            selectedMeetingTeam: null,
            meetingTypes: null,
            appointmentCampaign: null,
            selectedLocationId: null,
            selectedLocation: null,
            serviceDeliveryLocations: null,
            selectedServiceDeliveryLocation: null,
            selectedMeetingType: null,
            topics: [],
            selectedTopic: null,
            comment: "",
            timeSlots: null,
            selectedTimeSlot: null,
            isLoadingTimeSlots: false,
            courseSchedule: null,
            isSaving: false,
            isSaved: false,
            hasSaveError: false,
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
            saveErrorMessage: null,
            staffAndTeams: [],
            isLoadingStaffAndTeams: false,
            isLoadingTopics: false,
            showSelectLocationMessage: false,
            queryString: {},
            virtualizedApp: props.match.params.virtualizedApp,
            isNewMeetingSchedulerEnabled: null,
        };
        this.loadMeetingTypes = this.loadMeetingTypes.bind(this);
        this.loadAppointmentCampaign = this.loadAppointmentCampaign.bind(this);
        this.loadTimeSlots = this.loadTimeSlots.bind(this);
        this.selectMeetingTopic = this.selectMeetingTopic.bind(this);
        this.selectTimeSlot = this.selectTimeSlot.bind(this);
        this.selectMeetingType = this.selectMeetingType.bind(this);
        this.setComment = this.setComment.bind(this);
        this.save = this.save.bind(this);
        this.selectLocation = this.selectLocation.bind(this);
        this.onMeetingWithChange = this.onMeetingWithChange.bind(this);
        this.selectMeetingTeam = this.selectMeetingTeam.bind(this);
        this.renderMeetingWith = this.renderMeetingWith.bind(this);
        this.setAvailabilityDate = this.setAvailabilityDate.bind(this);
        this.renderLocation = this.renderLocation.bind(this);
        this.getStaffAndTeams = this.getStaffAndTeams.bind(this);
        this.getStudentLocations = this.getStudentLocations.bind(this);
        this.getIsNewMeetingSchedulerEnabled =
            this.getIsNewMeetingSchedulerEnabled.bind(this);
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        this.getIsNewMeetingSchedulerEnabled();
        // This prevents the warning message in meetingTopic from rendering
        this.setState({ isLoadingTopics: true });
        // Make sure that we are on the topic page.  If not, we need to redirect there.
        if (
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !this.props.location.pathname.includes(meetingTopicRoute()) &&
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            !this.props.location.pathname.includes(getMeetingDetailRoute())) {
            const paramsDelimiterIndex = window.location.href.indexOf("?");
            if (paramsDelimiterIndex !== -1) {
                window.location.replace(meetingTopicPath({}) +
                    window.location.href.substr(window.location.href.indexOf("?")));
                return;
            }
            window.location.replace(meetingTopicPath({}));
            return;
        }
        // Parse the query string.
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const queryString = qs.parse(this.props.location.search);
        this.setState({ queryString });
        // See if a withPersonId was passed in on the query string
        if (queryString.withPersonId) {
            const { withPersonId } = queryString;
            this.setState({ meetingWithPersonId: withPersonId });
            this.loadMeetingWithPerson(withPersonId);
        }
        if (queryString.topicId) {
            const topicId = parseInt(queryString.topicId, 10);
            const selectedTopic = this.state.topics.find((t) => t.id === topicId);
            this.selectMeetingTopic(selectedTopic);
        }
        // See if a studentAffiliationId was passed in on the query string. If this is the case,
        // this means the current user is using the scheduler to schedule a meeting on behalf of the
        // student referenced by the studentAffiliationId parameter.
        this.setState({
            studentAffiliationId: queryString.studentAffiliationId,
        }, () => {
            this.loadStudentPerson();
        });
        this.loadMeetingTypes();
        if (this.getCampaignId()) {
            this.loadAppointmentCampaign();
        }
        this.setState({
            isThirdPartyScheduler: !!queryString.studentAffiliationId,
        });
    }
    componentDidUpdate(prevProps, prevState) {
        const prevLocationId = prevState.selectedLocation
            ? prevState.selectedLocation.id
            : null;
        const currentLocationId = this.state.selectedLocation
            ? this.state.selectedLocation.id
            : null;
        /**
         * Getting the pathname and previous pathname
         * */
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const prevPathName = this.getPageFromPathName(prevProps.location.pathname);
        const currentPathName = this.getPageFromPathName(
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.location.pathname);
        if (
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.getPageFromPathName(prevProps.location.pathname) !==
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            this.getPageFromPathName(this.props.location.pathname)) {
            this.resetState();
        }
        if (prevLocationId !== currentLocationId) {
            // Reset who we're meeting with.  It's possible to choose a location for which these choices
            // aren't valid.  We want to always allow the student to change their location.
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                selectedMeetingTeam: null,
                meetingWithPersonId: prevLocationId === null && this.state.queryString.withPersonId
                    ? this.state.meetingWithPersonId
                    : null,
                meetingWith: prevLocationId === null && this.state.queryString.withPersonId
                    ? this.state.meetingWith
                    : null,
            }, () => {
                // When the location changes, this can change the services, service delivery locations
                // (departments), and people who are available in this UI. Therefore, update all the
                // necessary parts of the state with information that is filtered by the location they have
                // selected.
                this.loadMeetingTopics();
                this.getStaffAndTeams();
                this.loadServiceDeliveryLocations();
            });
        }
        /**
         * If the user hit the "Previous" button when on the "Scheduler" screen remove the AutoAssigned Person
         *  - this makes sure that the widget which displays "Meeting With {Name}" defaults to "Meeting with someone"
         * */
        if (prevPathName === "scheduler" && currentPathName === "type") {
            this.setState({
                meetingWithAutoAssignedPersonId: null,
                meetingWithAutoAssigned: null,
            });
        }
    }
    getCampaignId() {
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        return qs.parse(this.props.location.search).campaign;
    }
    /**
     * When a user navigates backwards, we want to clear out all the state that they had selected previously
     * Really, we should structure this so each step passes along its state to the next, instead of this
     * structure where we have one thing at the top orchestrating everything.  This is a hacky, in-between
     * and should be deleted as soon as possible.
     */
    resetState() {
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const location = this.getPageFromPathName(this.props.location.pathname);
        const index = PAGE_STATE_MAPPING.findIndex((mapping) => mapping.page === location);
        if (index > -1) {
            const nulledState = Object.assign({}, ...PAGE_STATE_MAPPING
                // Get everything after this page
                .slice(index + 1)
                // get all the state keys and set their value to null.
                .map((mapping) => (Object.assign(Object.assign({}, mapping.stateLists.reduce((sum, key) => {
                var _a;
                return (Object.assign(Object.assign({}, sum), { 
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7006 - Parameter 'obj' implicitly has an 'any' type.
                    [key]: (_a = this.state[key]) === null || _a === void 0 ? void 0 : _a.map((obj) => (Object.assign(Object.assign({}, obj), { isSelected: false }))) }));
            }, {})), mapping.state.reduce((sum, key) => (Object.assign(Object.assign({}, sum), { [key]: null })), {})))));
            this.setState(nulledState);
        }
    }
    getPageFromPathName(pathName) {
        var _a, _b;
        return (_b = (_a = pathName === null || pathName === void 0 ? void 0 : pathName.split("/")) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.trim();
    }
    loadStudentPerson() {
        return __awaiter(this, void 0, void 0, function* () {
            let studentPerson;
            if (this.state.studentAffiliationId) {
                studentPerson = yield PersonService.fetchPersonByAffiliationId(this.state.studentAffiliationId);
            }
            else {
                studentPerson = yield PersonService.me();
            }
            // @ts-expect-error - TS2741 - Property 'id' is missing in type 'import("/Users/dkrajnak/workspace/aviso/sse-frontend/react/components/shared/domainTypes/person.type").Person' but required in type 'import("/Users/dkrajnak/workspace/aviso/sse-frontend/react/models/Person").default'.
            this.setState({ studentPerson }, () => this.onStudentPersonChanged());
        });
    }
    loadStudentLocation() {
        return __awaiter(this, void 0, void 0, function* () {
            const location = yield MeetingService.fetchCurrentLocation(
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'personId' does not exist on type 'Person'.
            this.state.studentPerson.personId, this.getCampaignId());
            if (location) {
                // @ts-expect-error - TS2739 - Type 'LocationDto' is missing the following properties from type 'ServiceDeliveryLocation': url, isSelected, location
                this.setState({ selectedLocation: location });
            }
        });
    }
    loadCourseSchedule() {
        return __awaiter(this, void 0, void 0, function* () {
            const courseSchedule = yield StudentService.fetchCurrentSchedule(
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'personId' does not exist on type 'Person'.
            this.state.studentPerson.personId);
            this.setState({ courseSchedule });
        });
    }
    loadMeetingTopics() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ isLoadingTopics: true });
                let teamId = null;
                if (this.state.selectedMeetingTeam) {
                    teamId = this.state.selectedMeetingTeam.id;
                }
                // Fetch the meeting topics.  The endpoint this calls will not take into account the meeting
                // with person if we provide a team.  So, if we have a meeting with person, because we
                // only want to fetch topics for that person, we null out teamId.
                let meetingTopics = yield MeetingService.fetchMeetingTopics(
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                this.state.selectedLocation.id, 
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
                this.state.meetingWithPersonId, this.state.meetingWithPersonId ? null : teamId);
                if ((_b = (_a = this.state.appointmentCampaign) === null || _a === void 0 ? void 0 : _a.serviceOfferings) === null || _b === void 0 ? void 0 : _b.length) {
                    const validTopicsIds = this.state.appointmentCampaign.serviceOfferings.map((ele) => ele.id);
                    meetingTopics = meetingTopics.filter((topic) => {
                        return validTopicsIds.includes(topic.id);
                    });
                }
                // Sort the topics alphanumerically.
                meetingTopics.sort((a, b) => a.title.localeCompare(b.title));
                if (this.state.selectedTopic) {
                    const selectedTopic = meetingTopics.find(
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    (topic) => topic.id === this.state.selectedTopic.id);
                    if (!selectedTopic) {
                        console.error("Didn't find selected topic in list of refreshed topics: ", meetingTopics);
                    }
                    else {
                        selectedTopic.isSelected = true;
                    }
                }
                this.setState({ topics: meetingTopics });
            }
            catch (err) {
                // @ts-expect-error - TS2345 - Argument of type '{ errorMessage: any; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
                this.setState({ errorMessage: err.message });
            }
            finally {
                this.setState({ isLoadingTopics: false });
            }
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'personId' implicitly has an 'any' type.
    loadMeetingWithPerson(personId, autoAssigned = false) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2322 - Type 'import("/Users/dkrajnak/workspace/aviso/sse-frontend/react/components/shared/domainTypes/person.type").Person' is not assignable to type 'import("/Users/dkrajnak/workspace/aviso/sse-frontend/react/models/Person").default'.
            const person = yield PersonService.fetchPerson(personId);
            /**
             * When the user selects who they want to meet, "meetingWith" is used.
             * When the system auto selects then "meetingWithAutoAssigned" is used.
             * */
            // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Person; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
            this.setState({
                [autoAssigned ? "meetingWithAutoAssigned" : "meetingWith"]: person,
            });
        });
    }
    loadMeetingTypes() {
        return __awaiter(this, void 0, void 0, function* () {
            const meetingTypes = yield MeetingTypeService.fetchMeetingTypes(true, this.getCampaignId());
            this.setState({ meetingTypes });
        });
    }
    loadAppointmentCampaign() {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2741 - Property 'staffPeopleIds' is missing in type 'AppointmentCampaign' but required in type 'AppointmentCampaignInfo'.
            const appointmentCampaign = yield CampaignService.getAppointmentCampaignInfo(this.getCampaignId());
            this.setState({ appointmentCampaign }, () => {
                var _a, _b;
                let d = new Date();
                const start = ((_a = this.state.appointmentCampaign) === null || _a === void 0 ? void 0 : _a.startDate)
                    ? moment(this.state.appointmentCampaign.startDate)
                    : null;
                const end = ((_b = this.state.appointmentCampaign) === null || _b === void 0 ? void 0 : _b.endDate)
                    ? moment(this.state.appointmentCampaign.endDate)
                    : null;
                d.setHours(0, 0, 0, 0);
                if (start && start.isAfter(d)) {
                    d = start.toDate();
                }
                else if (end && end.isBefore(d)) {
                    // error
                }
                this.setAvailabilityDate(d);
            });
        });
    }
    loadTimeSlots() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: Since this function is called whenever the meeting type changes, it's quite possible
            // that the user would instantiate two concurrent AJAX calls to load time slots, and there's
            // certainly no need to keep anything but the latest result. We need to implement logic to
            // ensure there is only one request to get time slots at one time. It's OK (preferable) to keep
            // the results in the local cache, but we need to make sure the time slots state gets updated
            // with the information that resulted from the latest call to loadTimeSlots.
            this.setState({
                isLoadingTimeSlots: true,
                hasLoadingTimeSlotsError: false,
                loadingTimeSlotsErrorMessage: "",
            });
            try {
                const timeSlots = yield this.getTimeSlotsCached();
                const freeTimeSlots = timeSlots.filter((ts) => ts.status === STATUS_FREE);
                this.setState({
                    timeSlots: freeTimeSlots,
                });
            }
            catch (ex) {
                this.setState({
                    hasLoadingTimeSlotsError: true,
                    loadingTimeSlotsErrorMessage: "There was a problem loading the available time slots.",
                });
            }
            finally {
                this.setState({
                    isLoadingTimeSlots: false,
                });
            }
        });
    }
    getTimeSlotsCached() {
        var _a, _b, _c;
        const isTeam = !this.state.meetingWith && this.state.selectedMeetingTeam;
        if (isTeam) {
            // @ts-expect-error - TS2739 - Type 'TimeSlot[]' is missing the following properties from type 'Promise<TimeSlot[]>': then, catch, finally, [Symbol.toStringTag]
            return MeetingService.fetchTeamTimeSlotsCached(
            // @ts-expect-error - TS2345 - Argument of type 'number | null' is not assignable to parameter of type 'number'.
            this.state.selectedTopic ? this.state.selectedTopic.id : null, (_a = this.state.selectedMeetingTeam) === null || _a === void 0 ? void 0 : _a.id, this.state.availabilityDate, (_b = this.state.selectedMeetingType) === null || _b === void 0 ? void 0 : _b.durationMinutes, this.getCampaignId(), timeSlotsCache);
        }
        return MeetingService.fetchPersonTimeSlotsCached(
        // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
        this.state.meetingWithPersonId, this.state.availabilityDate, (_c = this.state.selectedMeetingType) === null || _c === void 0 ? void 0 : _c.durationMinutes, timeSlotsCache, this.state.selectedServiceDeliveryLocation, this.state.selectedTopic, this.getCampaignId());
    }
    // @ts-expect-error - TS7006 - Parameter 'meetingType' implicitly has an 'any' type.
    selectMeetingType(meetingType) {
        // Since we know the meeting type, we know the duration. We can go ahead and try pre-fetch the
        // availability for the user we're scheduling with to increase perceived performance. However,
        // since the loadTimeSlots method depends on the component's state to be updated with the
        // selected meeting type, we must wait for setState to complete, so we attach loadTimeSlots as
        // a callback when the state update is complete.
        this.selectSelectableItem("meetingTypes", meetingType, "selectedMeetingType", false, () => {
            this.setState({
                selectedServiceDeliveryLocation: null,
                selectedTimeSlot: null,
            }, () => this.loadTimeSlots());
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'topic' implicitly has an 'any' type.
    selectMeetingTopic(topic) {
        this.selectSelectableItem("topics", topic, "selectedTopic", false, this.loadServiceDeliveryLocations);
    }
    // @ts-expect-error - TS7006 - Parameter 'newComment' implicitly has an 'any' type.
    setComment(newComment) {
        this.setState({ comment: newComment });
    }
    // @ts-expect-error - TS7006 - Parameter 'timeSlot' implicitly has an 'any' type.
    selectTimeSlot(timeSlot) {
        /**
         * When user clicks on the selected timeslot, deselect the timeslot
         * */
        if (this.state.selectedTimeSlot &&
            this.state.selectedTimeSlot.startTime === timeSlot.startTime &&
            this.state.selectedTimeSlot.endTime === timeSlot.endTime) {
            this.setState({
                selectedTimeSlot: null,
                meetingWithAutoAssigned: null,
                meetingWithAutoAssignedPersonId: null,
            });
        }
        else {
            // Pick a random person from the team and load up their information.
            const randomPersonId = timeSlot.personIds[Math.floor(Math.random() * timeSlot.personIds.length)];
            /** *
             * When the user has selected the person they want to meet, update "meetingWithPersonId"
             */
            if (this.state.meetingWithPersonId &&
                randomPersonId !== this.state.meetingWithPersonId) {
                this.setState({ meetingWithPersonId: randomPersonId, selectedTimeSlot: timeSlot }, this.loadMeetingTopics);
                this.loadMeetingWithPerson(randomPersonId);
            }
            else {
                /**
                 * When the system auto selects the Person, update "meetingWithAutoAssignedPersonId"
                 * and only get the person information when its a different person than who was already selected
                 * */
                this.setState({
                    meetingWithAutoAssignedPersonId: randomPersonId,
                    selectedTimeSlot: timeSlot,
                });
                if (randomPersonId !== this.state.meetingWithAutoAssignedPersonId) {
                    this.loadMeetingWithPerson(randomPersonId, true);
                }
            }
        }
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            let departmentId;
            if (this.state.selectedServiceDeliveryLocation) {
                departmentId = this.state.selectedServiceDeliveryLocation.id;
            }
            else if (this.state.selectedMeetingTeam) {
                departmentId = this.state.selectedMeetingTeam.id;
            }
            let location;
            if (this.state.selectedServiceDeliveryLocation) {
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                location = `${this.state.selectedServiceDeliveryLocation.name} - ${this.state.selectedLocation.name}`;
            }
            const subject = `${this.state.meetingWith
                ? this.state.meetingWith.fullName
                : // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    this.state.meetingWithAutoAssigned.fullName
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            } <> ${this.state.studentPerson.fullName}`;
            // Populate event info based on current state.
            // Accept the location data
            const event = {
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'personId' does not exist on type 'Person'.
                studentPersonId: this.state.studentPerson.personId,
                advisorPersonId: this.state.meetingWithPersonId ||
                    this.state.meetingWithAutoAssignedPersonId,
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                startTime: new Date(this.state.selectedTimeSlot.startTime).toJSON(),
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                endTime: new Date(this.state.selectedTimeSlot.endTime).toJSON(),
                topicId: this.state.selectedTopic ? this.state.selectedTopic.id : null,
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                typeId: this.state.selectedMeetingType.id,
                departmentId,
                studentQuestion: this.state.comment,
                subject,
                location,
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                locationId: this.state.selectedLocation.id,
            };
            this.setState({ isSaving: true });
            try {
                yield MeetingService.saveEvent(event);
                this.setState({ isSaved: true });
            }
            catch (ex) {
                this.setState({
                    hasSaveError: true,
                    saveErrorMessage: typeof ex === "string" ? ex : "There was a problem saving the event.",
                });
                console.debug("Error saving event", ex);
            }
            finally {
                this.setState({ isSaving: false });
            }
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'location' implicitly has an 'any' type.
    selectLocation(location) {
        this.selectSelectableItem("serviceDeliveryLocations", location, "selectedServiceDeliveryLocation", false, () => {
            this.loadTimeSlots();
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'team' implicitly has an 'any' type.
    selectMeetingTeam(team) {
        // @ts-expect-error - TS2554 - Expected 5 arguments, but got 4.
        this.selectSelectableItem("serviceDeliveryLocations", team, "selectedMeetingTeam", false);
        this.loadMeetingTopics();
        // If there is a meeting type selected, we need to re-fetch the available time slots.
        if (this.state.selectedMeetingType) {
            this.loadTimeSlots();
        }
    }
    selectSelectableItem(
    // @ts-expect-error - TS7006 - Parameter 'arrayStateKey' implicitly has an 'any' type.
    arrayStateKey, 
    // @ts-expect-error - TS7006 - Parameter 'selectedItem' implicitly has an 'any' type.
    selectedItem, 
    // @ts-expect-error - TS7006 - Parameter 'selectedItemStateKey' implicitly has an 'any' type.
    selectedItemStateKey, 
    // @ts-expect-error - TS7006 - Parameter 'isMultiSelect' implicitly has an 'any' type.
    isMultiSelect, 
    // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
    callback) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Readonly<State>'.
        const arrayCopy = this.state[arrayStateKey].slice();
        if (!isMultiSelect) {
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            arrayCopy.forEach((item) => {
                item.isSelected = false;
            });
        }
        if (selectedItem) {
            selectedItem.isSelected = true;
        }
        const newState = {};
        newState[arrayStateKey] = arrayCopy;
        if (selectedItemStateKey) {
            newState[selectedItemStateKey] = selectedItem;
        }
        // @ts-expect-error - TS2345 - Argument of type 'Record<string, any>' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
        this.setState(newState, callback);
    }
    getStaffAndTeams() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ isLoadingStaffAndTeams: true });
                const responseJson = yield MeetingService.fetchStaffAndTeams(
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                this.state.selectedLocation.id, this.getCampaignId());
                // @ts-expect-error - TS7034 - Variable 'options' implicitly has type 'any[]' in some locations where its type cannot be determined.
                let options = [];
                // Convert the result to a single collection of options by combining both staff and teams.
                // @ts-expect-error - TS7005 - Variable 'options' implicitly has an 'any[]' type.
                options = options.concat(
                // @ts-expect-error - TS7006 - Parameter 'staff' implicitly has an 'any' type.
                responseJson.data.staff.map((staff) => ({
                    id: staff.personId,
                    fullName: `${staff.firstName} ${staff.lastName}`,
                    isTeam: false,
                })));
                options = options.concat(
                // @ts-expect-error - TS7006 - Parameter 'dept' implicitly has an 'any' type.
                responseJson.data.departments.map((dept) => ({
                    id: dept.id,
                    fullName: dept.name,
                    isTeam: true,
                })));
                this.setState({ staffAndTeams: options });
                return options;
            }
            catch (err) {
                // @ts-expect-error - TS2345 - Argument of type '{ errorMessage: any; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
                this.setState({ errorMessage: err.message });
            }
            finally {
                this.setState({ isLoadingStaffAndTeams: false });
            }
            return null;
        });
    }
    getStudentLocations() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = yield MeetingService.fetchLocationsWithServices({
                campaignId: this.getCampaignId(),
            });
            return { options };
        });
    }
    loadServiceDeliveryLocations() {
        return __awaiter(this, void 0, void 0, function* () {
            let selectedTopicId = null;
            if (this.state.selectedTopic) {
                selectedTopicId = this.state.selectedTopic.id;
            }
            const serviceDeliveryLocations = yield MeetingService.fetchServiceDeliveryLocations(
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            this.state.selectedLocation.id, 
            // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
            this.state.meetingWithPersonId, selectedTopicId);
            // @ts-expect-error - TS2345 - Argument of type '{ serviceDeliveryLocations: Location[]; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
            this.setState({ serviceDeliveryLocations });
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'meetingWith' implicitly has an 'any' type.
    onMeetingWithChange(meetingWith) {
        return __awaiter(this, void 0, void 0, function* () {
            if (meetingWith.isTeam) {
                const team = yield MeetingService.fetchTeam(meetingWith.id);
                this.setState({
                    selectedMeetingTeam: team,
                    meetingWithPersonId: null,
                }, () => {
                    this.loadMeetingTopics();
                });
            }
            else {
                this.setState({ meetingWithPersonId: meetingWith.id }, () => {
                    this.loadMeetingWithPerson(meetingWith.id).then(() => {
                        this.loadMeetingTopics();
                        this.loadServiceDeliveryLocations();
                    });
                });
            }
        });
    }
    renderSelectedLocation() {
        const location = (this.state.meetingWith && this.state.meetingWith.locationName) ||
            (this.state.selectedMeetingTeam &&
                this.state.selectedMeetingTeam.location);
        if (!location) {
            return null;
        }
        return (_jsx("a", { href: location.url, target: "_blank", rel: "noopener noreferrer", children: _jsxs("small", { children: [_jsx("span", { className: "fas fa-map-marker-alt", "aria-hidden": "true" }), " ", location.name] }) }));
    }
    renderLoadingStaffAndTeamsOrNobodyAvailable() {
        if (this.state.isLoadingStaffAndTeams) {
            return _jsx(Busy, { isBusy: true });
        }
        return (_jsxs("div", { className: "alert alert-info", children: [_jsx("span", { className: "fa fa-info-circle" }), " There is nobody available for scheduled meetings at the selected location."] }));
    }
    renderMeetingWith() {
        if (this.state.meetingWithAutoAssigned) {
            return (_jsx("div", { className: "mb-3", children: _jsx(MeetingWithDisplay, { meetingWith: this.state.meetingWithAutoAssigned }) }));
        }
        if (this.state.selectedMeetingTeam) {
            return (_jsx("div", { className: "mb-4", children: _jsxs("div", { className: "media", children: [_jsx("div", { className: "mr-3", children: this.state.meetingWith ? (
                            // @ts-expect-error - TS2769 - No overload matches this call.
                            _jsx(ProfilePicture, { person: this.state.meetingWith })) : (_jsx("span", { className: "fa fa-users", "aria-hidden": "true" })) }), _jsxs("div", { className: "media-body", children: [_jsxs("h6", { className: "media-heading mb-1", children: ["Meeting with", " ", this.state.meetingWith
                                            ? this.state.meetingWith.fullName
                                            : "someone", " ", "from ", this.state.selectedMeetingTeam.name] }), _jsx("div", { children: this.renderSelectedLocation() })] })] }) }));
        }
        if (this.state.meetingWith) {
            return (_jsx("div", { className: "mb-3", children: _jsx(MeetingWithDisplay, { meetingWith: this.state.meetingWith }) }));
        }
        return (_jsx("div", { className: "mb-4", children: this.state.staffAndTeams.length ? (_jsxs("div", { children: [_jsxs("h3", { children: ["Know who", " ", this.state.isThirdPartyScheduler
                                ? "the student wants"
                                : "you want", " ", "to meet with?"] }), _jsx(DeprecatedSelect, { "aria-label": `Know who ${this.state.isThirdPartyScheduler
                            ? "the student wants"
                            : "you want"} to meet with?`, isLoading: this.state.isLoadingStaffAndTeams, labelKey: "fullName", onChange: this.onMeetingWithChange, options: this.state.staffAndTeams, value: this.state.meetingWithPersonId, valueKey: "id" }), _jsx("small", { children: "Can be left blank if there is no preference." })] })) : (this.renderLoadingStaffAndTeamsOrNobodyAvailable()) }));
    }
    /**
     * Location is a required field
     * */
    renderLocation() {
        return (_jsxs("div", { children: [_jsx("h3", { children: "Choose a location" }), _jsx(DeprecatedSelect.Async, { "aria-label": "Choose a location", loadOptions: this.getStudentLocations, valueKey: "id", labelKey: "name", value: this.state.selectedLocation, onChange: (location) => this.setState({ selectedLocation: location }), clearable: false })] }));
    }
    // @ts-expect-error - TS7006 - Parameter 'availabilityDate' implicitly has an 'any' type.
    setAvailabilityDate(availabilityDate) {
        // Make sure it's midnight
        availabilityDate.setHours(0, 0, 0, 0);
        this.setState({ availabilityDate }, this.loadTimeSlots);
    }
    getIsNewMeetingSchedulerEnabled() {
        return __awaiter(this, void 0, void 0, function* () {
            const isNewMeetingSchedulerEnabled = yield FeatureService.isGlobalFeatureEnabled("newScheduler");
            this.setState({ isNewMeetingSchedulerEnabled });
        });
    }
    render() {
        return (_jsxs("div", { className: "container-fluid mt-3", children: [_jsx(SEO, { title: "Schedule Meeting" }), !!this.getCampaignId() &&
                    this.state.appointmentCampaign &&
                    AppointmentCampaignInfoDomainService.getInfoTextFieldsForMeetingScheduler(this.state.appointmentCampaign).length > 0 && (_jsx(AlertInfo, { message: _jsxs(_Fragment, { children: ["There are restrictions on scheduling this appointment.", _jsx("button", { className: "btn btn-link p-0 ml-1 alert-link", "data-toggle": "collapse", "data-target": "#appointmentInfo", "aria-expanded": "false", "aria-controls": "collapseExample", children: "More info" })] }) })), this.state.appointmentCampaign && (_jsx("div", { className: "collapse", id: "appointmentInfo", children: _jsx(CustomCard, { noShadow: true, className: "mb-3", children: _jsx("div", { className: "card-body", children: _jsx("div", { className: "row", children: AppointmentCampaignInfoDomainService.getInfoTextFieldsForMeetingScheduler(this.state.appointmentCampaign).map((info, i) => (_jsx("div", { className: "col-6", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "appointment-info-" + i, children: info.label }), _jsx("div", { id: "appointment-info-" + i, children: info.value })] }) }, i))) }) }) }) })), this.state.isThirdPartyScheduler && this.state.studentPerson && (_jsxs("div", { className: "media mb-4", children: [_jsx("div", { className: "mr-3", children: this.state.studentPerson ? (
                            // @ts-expect-error - TS2769 - No overload matches this call.
                            _jsx(ProfilePicture, { person: this.state.studentPerson })) : (_jsx("span", { className: "fa fa-users", "aria-hidden": "true" })) }), _jsx("div", { className: "media-body", children: _jsxs("h6", { className: "media-heading mb-1", children: ["Scheduling meeting for ", this.state.studentPerson.fullName] }) })] })), _jsx("div", { className: "mb-4", children: _jsx(Route, { path: getPreBaseRoute() + meetingTopicRoute(), render: this.renderLocation }) }), this.state.selectedLocation && (_jsxs(Switch, { children: [_jsx(Route, { path: getPreBaseRoute() + getMeetingTeamRoute(), 
                            // @ts-expect-error - TS2769 - No overload matches this call.
                            component: null }), _jsx(Route, { path: getPreBaseRoute() + getMeetingDetailRoute(), 
                            // @ts-expect-error - TS2769 - No overload matches this call.
                            component: null }), _jsx(Route, { render: this.renderMeetingWith })] })), _jsx(Switch, { children: _jsxs(ScrollToTop, { children: [_jsx(Route, { path: getPreBaseRoute() + meetingTopicRoute(), render: () => {
                                    var _a;
                                    if (this.state.isNewMeetingSchedulerEnabled == null) {
                                        return null;
                                    }
                                    if (this.state.isNewMeetingSchedulerEnabled == true) {
                                        const queryParams = qs.parse(this.getQueryString());
                                        return (_jsx(Redirect, { to: getMeetingsSchedulePath({
                                                virtualizedApp: this.state.virtualizedApp,
                                                stableSearchParams: {
                                                    staffId: queryParams.withPersonId,
                                                    serviceId: queryParams.topicId,
                                                    studentId: queryParams.studentAffiliationId,
                                                    campaignId: queryParams.campaign,
                                                },
                                            }) }));
                                    }
                                    if (this.state.isNewMeetingSchedulerEnabled == false) {
                                        return (_jsx(MeetingTopic, { isLoading: this.state.isLoadingTopics, isThirdPartyScheduler: this.state.isThirdPartyScheduler, topics: this.state.topics, selectMeetingTopic: this.selectMeetingTopic, 
                                            // @ts-expect-error - TS2322 - Type 'ServiceDeliveryLocation | null | undefined' is not assignable to type 'LocationDto'.
                                            selectedLocation: this.state.selectedLocation, comment: this.state.comment, onCommentChange: this.setComment, hasMeetingWith: !!(this.state.meetingWith ||
                                                this.state.selectedMeetingTeam), 
                                            // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean'.
                                            hasToPickSomeoneToMeetWith: this.state.appointmentCampaign &&
                                                ((_a = this.state.appointmentCampaign) === null || _a === void 0 ? void 0 : _a.staffPeople.length) > 0, hasPeopleAtLocation: !!this.state.staffAndTeams.length, pageParams: this.getQueryString(), virtualizedApp: this.state.virtualizedApp }));
                                    }
                                } }), _jsx(Route, { path: getPreBaseRoute() + getMeetingTypeRoute(), render: () => {
                                    if (this.state.isNewMeetingSchedulerEnabled == null) {
                                        return null;
                                    }
                                    if (this.state.isNewMeetingSchedulerEnabled == true) {
                                        const queryParams = qs.parse(this.getQueryString());
                                        return (_jsx(Redirect, { to: getMeetingsSchedulePath({
                                                virtualizedApp: this.state.virtualizedApp,
                                                stableSearchParams: {
                                                    staffId: queryParams.withPersonId,
                                                    serviceId: queryParams.topicId,
                                                    studentId: queryParams.studentAffiliationId,
                                                    campaignId: queryParams.campaign,
                                                },
                                            }) }));
                                    }
                                    return (_jsx(MeetingType, { hasMeetingWith: !!(this.state.meetingWith || this.state.selectedMeetingTeam), isThirdPartyScheduler: this.state.isThirdPartyScheduler, 
                                        // @ts-expect-error - TS2322 - Type 'MeetingType[] | null | undefined' is not assignable to type 'MeetingType[]'.
                                        meetingTypes: this.state.meetingTypes, selectMeetingType: this.selectMeetingType, 
                                        // @ts-expect-error - TS2322 - Type 'MeetingType | null | undefined' is not assignable to type 'MeetingType'.
                                        selectedMeetingType: this.state.selectedMeetingType, 
                                        // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean'.
                                        enableLocationSelection: !this.state.selectedMeetingTeam &&
                                            this.state.selectedMeetingType &&
                                            this.state.selectedMeetingType.requiresLocation, 
                                        // @ts-expect-error - TS2339 - Property 'serviceDeliveryLocations' does not exist on type 'Readonly<State>'.
                                        locations: this.state.serviceDeliveryLocations, selectLocation: this.selectLocation, selectedLocation: this.state.selectedServiceDeliveryLocation, selectedMeetingTeam: this.state.selectedMeetingTeam, pageParams: this.getQueryString(), virtualizedApp: this.state.virtualizedApp }));
                                } }), _jsx(Route, { path: getPreBaseRoute() + getMeetingTeamRoute(), render: () => (_jsx(MeetingTeam, { isThirdPartyScheduler: this.state.isThirdPartyScheduler, 
                                    // @ts-expect-error - TS2339 - Property 'serviceDeliveryLocations' does not exist on type 'Readonly<State>'.
                                    meetingTeams: this.state.serviceDeliveryLocations, selectMeetingTeam: this.selectMeetingTeam, pageParams: this.getQueryString(), virtualizedApp: this.state.virtualizedApp })) }), _jsx(Route, { path: getPreBaseRoute() + getMeetingSchedulerRoute(), render: () => {
                                    var _a, _b;
                                    if (this.state.isNewMeetingSchedulerEnabled == null) {
                                        return null;
                                    }
                                    if (this.state.isNewMeetingSchedulerEnabled == true) {
                                        const queryParams = qs.parse(this.getQueryString());
                                        return (_jsx(Redirect, { to: getMeetingsSchedulePath({
                                                virtualizedApp: this.state.virtualizedApp,
                                                stableSearchParams: {
                                                    staffId: queryParams.withPersonId,
                                                    serviceId: queryParams.topicId,
                                                    studentId: queryParams.studentAffiliationId,
                                                    campaignId: queryParams.campaign,
                                                },
                                            }) }));
                                    }
                                    return (_jsx(MeetingScheduler, { availabilityDate: this.state.availabilityDate, onAvailabilityDateChange: this.setAvailabilityDate, loadTimeSlots: this.loadTimeSlots, 
                                        // @ts-expect-error - TS2322 - Type 'TimeSlot[] | null | undefined' is not assignable to type 'TimeSlot[]'.
                                        timeSlots: this.state.timeSlots, isLoadingTimeSlots: this.state.isLoadingTimeSlots, hasLoadingTimeSlotsError: this.state.hasLoadingTimeSlotsError, loadingTimeSlotsErrorMessage: this.state.loadingTimeSlotsErrorMessage, isThirdPartyScheduler: this.state.isThirdPartyScheduler, courseSchedule: this.state.courseSchedule, onTimeSlotSelected: this.selectTimeSlot, 
                                        // @ts-expect-error - TS2322 - Type 'TimeSlot | null | undefined' is not assignable to type 'TimeSlot'.
                                        selectedTimeSlot: this.state.selectedTimeSlot, meetingTeam: this.state.selectedMeetingTeam, pageParams: this.getQueryString(), 
                                        // @ts-expect-error - TS2322 - Type 'Date | null | undefined' is not assignable to type 'Date | undefined'.
                                        startRange: (_a = this.state.appointmentCampaign) === null || _a === void 0 ? void 0 : _a.startDate, 
                                        // @ts-expect-error - TS2322 - Type 'Date | null | undefined' is not assignable to type 'Date | undefined'.
                                        endRange: (_b = this.state.appointmentCampaign) === null || _b === void 0 ? void 0 : _b.endDate, virtualizedApp: this.state.virtualizedApp }));
                                } }), _jsx(Route, { path: getPreBaseRoute() + getMeetingConfirmRoute(), render: () => {
                                    var _a;
                                    if (this.state.isNewMeetingSchedulerEnabled == null) {
                                        return null;
                                    }
                                    if (this.state.isNewMeetingSchedulerEnabled == true) {
                                        const queryParams = qs.parse(this.getQueryString());
                                        return (_jsx(Redirect, { to: getMeetingsConfirmationPath({
                                                virtualizedApp: this.state.virtualizedApp,
                                                confirmationSearchParams: {
                                                    // @ts-expect-error TS mess, will fix if I got time
                                                    startTime: this.state.selectedTimeSlot.startTime,
                                                    officeId: this.state.selectedServiceDeliveryLocation.id,
                                                    staffId: queryParams.withPersonId,
                                                    // @ts-expect-error TS mess, will fix if I got time
                                                    serviceId: (_a = this.state.selectedTopic) === null || _a === void 0 ? void 0 : _a.id,
                                                    studentId: queryParams.studentAffiliationId,
                                                },
                                            }) }));
                                    }
                                    return (_jsx(MeetingConfirm
                                    // @ts-expect-error - TS2322 - Type 'MeetingType | null | undefined' is not assignable to type 'MeetingType'.
                                    , { 
                                        // @ts-expect-error - TS2322 - Type 'MeetingType | null | undefined' is not assignable to type 'MeetingType'.
                                        meetingType: this.state.selectedMeetingType, 
                                        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                        startTime: this.state.selectedTimeSlot.startTime, durationMinutes: 
                                        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                        this.state.selectedMeetingType.durationMinutes, 
                                        // @ts-expect-error - TS2322 - Type 'MeetingTopic | null | undefined' is not assignable to type 'MeetingTopic'.
                                        topic: this.state.selectedTopic, comment: this.state.comment, onCommentChange: this.setComment, onSave: this.save, isSaving: this.state.isSaving, isSaved: this.state.isSaved, isThirdPartyScheduler: this.state.isThirdPartyScheduler, hasSaveError: this.state.hasSaveError, saveErrorMessage: this.state.saveErrorMessage, selectedLocation: this.state.selectedServiceDeliveryLocation, pageParams: this.getQueryString(), virtualizedApp: this.state.virtualizedApp }));
                                } }), _jsx(Route, { path: getPreBaseRoute() + getMeetingDetailRoute() + ID_VARIABLE(), render: ({ match }) => {
                                    if (!match.params.id) {
                                        return (_jsx(Redirect, { to: getPreBaseRoute() + getMeetingsBaseRoute() }));
                                    }
                                    if (this.state.isNewMeetingSchedulerEnabled == null) {
                                        return null;
                                    }
                                    if (this.state.isNewMeetingSchedulerEnabled == true) {
                                        return (_jsx(Redirect, { to: {
                                                pathname: getMeetingsDetailPath(parseInt(match.params.id, 10), {
                                                    virtualizedApp: match.params.virtualizedApp,
                                                }),
                                                search: this.getQueryString(),
                                            } }));
                                    }
                                    return (_jsx(MeetingDetail, { match: {
                                            params: {
                                                id: match.params.id,
                                                virtualizedApp: match.params.virtualizedApp,
                                            },
                                        } }));
                                } })] }) })] }));
    }
}
